import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Cancel} from '@material-ui/icons';
import {T} from 'Actions/translate';
import util from 'Utils/commonUtil';

class BasicOnInput extends Component {
    state = {
        emptyValidation: true,
        focus: false,
        firstAssignValue: true,
        legalEmail: true,
    };

    componentWillReceiveProps(nextProps) {
        if (this.input) {
            if (
                this.state.firstAssignValue &&
                util.isString(nextProps.defalutValue)
            ) {
                this.input.value = nextProps.defalutValue;
                this.props.inputValid(this.props.title, nextProps.defalutValue);

                this.setState({
                    firstAssignValue: false,
                });
            } else if (
                nextProps.value !== this.input.value &&
                util.isString(nextProps.value)
            ) {
                if (nextProps.title === 'billToEmail') {
                    let emptyEmail = true;
                    let isNotEmail = true;
                    if (nextProps.value) {
                        if (
                            nextProps.isSearchChange !== 'undefined' &&
                            nextProps.isSearchChange
                        ) {
                            isNotEmail = this.checkEmailFormat(
                                nextProps.value,
                                isNotEmail,
                            );
                        } else {
                            isNotEmail = this.checkEmailFormat(
                                this.input.value,
                                isNotEmail,
                            );
                        }
                    } else {
                        emptyEmail = false;
                    }
                    this.setState({
                        emptyValidation: emptyEmail,
                        legalEmail: isNotEmail,
                    });
                    this.input.value = isNotEmail
                        ? nextProps.value
                        : this.input.value;
                } else {
                    this.input.value = nextProps.value;
                }
            }
        }
    }

    checkEmailFormat = (eamil, isNotEmail) => {
        if (eamil && eamil.length > 0) {
            // const strReg=/^\w+((-\w+)|(\.\w+))*\@{1}\w+\.{1}\w{2,4}(\.{0,1}\w{2}){0,1}/ig;
            const strReg = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/; // Update SCME-3095
            const isRegFlag = eamil.search(strReg);
            if (isRegFlag === -1) {
                isNotEmail = false;
            }
        }
        return isNotEmail;
    };

    clearInput = () => {
        this.input.value = '';

        let empty = true;
        if (
            typeof this.props.checkEmail !== 'undefined' &&
            this.props.checkEmail
        ) {
            this.setState({
                emptyValidation: false,
            });
        }
        this.props.inputValid(this.props.title, '');
    };

    foucusInput = () => {
        this.setState({
            focus: true,
        });

        if (util.isFunction(this.props.blurFoucus)) {
            this.props.blurFoucus();
        }
    };

    blurAction = () => {
        setTimeout(() => {
            this.setState({
                focus: false,
            });
            if (util.isFunction(this.props.blurAction)) {
                this.props.blurAction();
            }
        }, 200);
    };

    inputValid = (title) => (event) => {
        let empty = true;
        let isNotEmail = true;
        if (!event.target.value && this.props.required) {
            empty = false;
        }
        if (
            typeof this.props.checkEmail !== 'undefined' &&
            this.props.checkEmail
        ) {
            if (event.target.value && event.target.value.length > 0) {
                isNotEmail = this.checkEmailFormat(
                    event.target.value,
                    isNotEmail,
                );
            }

            this.setState({
                emptyValidation: empty,
                legalEmail: isNotEmail,
            });
            this.props.inputValid(title, event.target.value, isNotEmail);
        } else {
            this.setState({
                emptyValidation: empty,
            });
            this.props.inputValid(title, event.target.value);
        }
    };

    render() {
        const {
            title,
            placeholder,
            type,
            disabled,
            defaultValue,
            smallBasicInput,
            checkEmail,
            isChangeBillToConsignee,
            testid,
        } = this.props;
        const {emptyValidation, focus, legalEmail} = this.state;

        return (
            <div className="basic-input-container">
                <div
                    className={
                        emptyValidation
                            ? typeof checkEmail !== 'undefined'
                                ? 'basic-input eamil-basic-input'
                                : 'basic-input'
                            : 'basic-input empty'
                    }>
                    {!util.getPropertyExistsAndIsTrue(smallBasicInput) ? (
                        <label className="input-title">{T(title)}</label>
                    ) : null}
                    <input
                        title={this.props.value}
                        className={
                            util.getPropertyExistsAndIsTrue(smallBasicInput)
                                ? 'input-content small-input-content'
                                : 'input-content'
                        }
                        onChange={this.inputValid(title)}
                        placeholder={
                            emptyValidation
                                ? T(placeholder)
                                : T('input_required')
                        }
                        type={type || 'text'}
                        defaultValue={defaultValue || ''}
                        ref={(input) => (this.input = input)}
                        onBlur={this.blurAction}
                        onFocus={this.foucusInput}
                        testid={testid ? `${testid}-input` : ''}
                        disabled={disabled}
                    />
                    {this.input && this.input.value && focus ? (
                        <Cancel
                            className={
                                util.getPropertyExistsAndIsTrue(smallBasicInput)
                                    ? 'cancel-button small-cancel-button'
                                    : 'cancel-button'
                            }
                            onClick={this.clearInput}
                        />
                    ) : null}
                </div>

                {emptyValidation && !legalEmail ? (
                    <div className="illegal-message">{T('errorEmail')}</div>
                ) : null}
            </div>
        );
    }
}

BasicOnInput.propTypes = {
    title: PropTypes.string.isRequired,
};

export default BasicOnInput;
